import styled, { css } from 'styled-components';

interface IContainerProps {
  status: string;
}

export const Container = styled.div<IContainerProps>`
  ${({ theme, status }) => css`
    width: 90px;
    padding: 4px 2px;
    display: flex;
    justify-content: center;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;

    ${status === 'Pendente' &&
    css`
      background: ${theme.colors.pendingStatus};
    `}

    ${status === 'Finalizado' &&
    css`
      background: ${theme.colors.finishedStatus};
    `}

    ${status === 'Cancelado' &&
    css`
      background: ${theme.colors.canceledStatus};
    `}
  `}
`;
